import { AccountCircleIcon } from './AccountCircleIcon';

/**
 * author: Google
 * id 1D7E8F31-998D-442A-80E6-EBB8DFA8CBA2
 * name account-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-circle.svg
 * tags
 * - Account / User 
 */
export const UserCircleIcon = AccountCircleIcon;
export default UserCircleIcon